import { defineComponent as _defineComponent } from 'vue'
import { mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent } from "vue"

import { ref, watch, useAttrs, toRaw, computed, nextTick } from 'vue'
import { every as lodashEvery, debounce } from 'lodash-es'
import { getTreeIds, getTreeNameList } from '@/utils/index'
import CosInputView from '@/components/Antd/CosView/input.vue'


const __default__ = { name: 'CosCascader' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    value: {},
    ids: {},
    type: {},
    view: { type: Boolean }
  },
  emits: ['update:value', 'update:label', 'update:ids', 'change'],
  setup(__props: any, { emit: __emit }) {

const attrs = useAttrs()

const props = __props
const current = ref<(number | string)[]>([])

// 监听并回显数据（需要添加函数防抖）
const valueFormat = debounce((value: any, options: any) => {
  // console.log('CosCascader--value和options更新,已防抖：', value, options)
  if (!value || !options) return (current.value = [])
  // 判断是否多选，多选 value 为数组，单选为字符串或数字
  const isMultiple = Array.isArray(value)
  if (isMultiple) {
    const result = value.reduce((arr: any[], cur: any[]) => {
      arr.push(getTreeIds(options, cur))
      return arr
    }, [])
    current.value = result
  } else {
    current.value = getTreeIds(options, value)
  }
}, 200)
watch(
  () => [props.value, props.ids, attrs.options],
  (newValue, oldValue) => {
    const [value, ids, options] = newValue
    if (props.type === 'search') {
      if (ids == null) {
        current.value = []
      } else {
        valueFormat(ids, options)
      }
    } else {
      valueFormat(value, options)
    }
  },
  { immediate: true, deep: true }
)

const currentTxt = computed(() => {
  if (props.value && attrs.options) {
    const labelList = getTreeNameList(attrs.options, props.value, attrs.fieldNames)
    return labelList.join('/') || '--'
  }
  return props.value || '--'
})

const emit = __emit
const change = (value: any, selectedOptions: any) => {
  // 1、当 value 不存在时直接返回 undefined
  // 2、或者当 value 为数组且为空数组时，则直接返回 undefined
  if (value == null || (Array.isArray(value) && value.length === 0)) {
    emit('update:value', undefined)
    emit('update:label', undefined)
    emit('update:ids', undefined)
    emit('change', undefined)
    return
  }
  // 判断是否多选，antd 级联多选返回二维数组，单选返回一维数组
  const isMultiple = lodashEvery(value, (item) => Array.isArray(item))
  if (isMultiple) {
    let result = []
    let searchResult = []
    if (props.type === 'search') {
      const lastSelectedOptionList = selectedOptions.map((item: any) => toRaw([item[item.length - 1]]))
      searchResult = lastSelectedOptionList.reduce((arr: any[], current: any[]) => arr.concat(getIds(current)), [])
      emit('update:ids', searchResult)
    } else {
      result = value.reduce((arr: any[], current: any[]) => arr.concat(current[current.length - 1]), [])
      emit('update:value', result)
    }
    emit('change', { custom: props.type === 'search' ? searchResult : result, source: value })
  } else {
    const lastValue = value[value.length - 1]
    if (props.type === 'search') {
      const lastSelectedOption = selectedOptions[selectedOptions.length - 1]
      emit('update:ids', getIds([lastSelectedOption]))
    } else {
      emit('update:value', lastValue)
    }
    emit('change', { custom: lastValue, source: value })
    nextTick(() => {
      emit('update:label', currentTxt.value)
    })
  }
}

// 获取所有 id
const getIds = (data: any[] = [], arr: (string | number)[] = []) => {
  data.forEach((item: any) => {
    arr.push(item.id)
    if (item.children && item.children.length) {
      getIds(item.children, arr)
    }
  })
  return arr
}

return (_ctx: any,_cache: any) => {
  const _component_a_cascader = _resolveComponent("a-cascader")!

  return (_ctx.view)
    ? (_openBlock(), _createBlock(CosInputView, _mergeProps({ key: 0 }, _ctx.$attrs, { value: currentTxt.value }), null, 16, ["value"]))
    : (_openBlock(), _createBlock(_component_a_cascader, _mergeProps({ key: 1 }, _ctx.$attrs, {
        value: current.value,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((current).value = $event)),
        showSearch: "",
        onChange: change,
        "change-on-select": ""
      }), null, 16, ["value"]))
}
}

})